/* global angular */

(function () {
'use strict';

  angular.module('gc.directives', [])

  /**
   * MinLength directive which doesn't set ng-model value to 'undefined'
   * if limit is reached. See https://stackoverflow.com/a/17076323/505836
   */
  .directive('minLengthForgiving', function() {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModelCtrl) {
        var minlength = Number(attrs.minLengthForgiving);
        function fromUser(text) {
          ngModelCtrl.$setValidity('min-length', text.length >= minlength);
          return text;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  })

  /**
   * MaxLength directive which doesn't set ng-model value to 'undefined'
   * if limit is reached. See https://stackoverflow.com/a/17076323/505836
   */
  .directive('maxLengthForgiving', function() {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModelCtrl) {
        var maxlength = Number(attrs.maxLengthForgiving);
        function fromUser(text) {
          ngModelCtrl.$setValidity('max-length', text.length <= maxlength);
          return text;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  })

  /**
   * MaxLength for contenteditable elemnts
   */
  .directive('editableMaxlength', function() {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModelCtrl) {
        var maxLength = Number(attrs.editableMaxlength);
        element.on('keydown paste', function(event) {
          if ($(this).text().length >= maxLength && event.keyCode != 8) {
            event.preventDefault();
          }
        });
      }
    };
  })

  .directive('waitImageLoaded', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        $(element).css('visibility', 'hidden');
        element.bind('load', function() {
          $(element).css('visibility', 'visible');
        });
        element.bind('error', function(){});
      }
    };
  })

  .directive('convertToNumber', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function(val) {
          if (val === '') return null;
          return parseInt(val, 10);
        });
        ngModel.$formatters.push(function(val) {
          return '' + val;
        });
      }
    };
  })

  .directive('time', ['$filter', function($filter) {
    return {
      restrict: 'E',
      link: function(scope, element, attributes) {
        if (!attributes.datetime) return;
        var date = moment(attributes.datetime, 'YYYY-MM-DD HH:mm:ss').toDate();
        setInterval(function() {
          element.text($filter('fromNow')(date));
        }, 1000 * 60);
      }
    };
  }])

  // https://stackoverflow.com/a/26928248/505836
  .directive('visible', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attributes) {
        scope.$watch(attributes.visible, function(value){
          element.css('visibility', value ? 'visible' : 'hidden');
        });
      }
    };
  })

  /**
   * Dangerous: allow to outpass angular ng-bind-html
   * (to execute <script></script> for example)
   * see https://stackoverflow.com/a/25431736/505836
   *
   * Used to display ads (don't use this directive for anything else)
   */
  .directive('html', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element[0].insertAdjacentHTML('beforeend', attrs.html);
        $timeout(function() {
          var $scripts = element[0].querySelectorAll('script');
          for (var i = 0; i < $scripts.length; i++) {
            eval($scripts[i].innerHTML);
          }
        }, Number(attrs.htmlScriptTimeout) || 0);
      }
    }
  }]);

})();
